import {
  isAvailable,
  priceProvenanceText,
  priceUpdatedFor,
} from "../../../services/valuation";
import { DateFormat, formatDate } from "../../../utils";
import { HistoryPointView, PointProvenance } from "./types";

// A blocked point's provenances describe only the positions that did price, so naming a source there would vouch for a value it withholds.
export const pointProvenanceOf = (point: HistoryPointView): PointProvenance => {
  if (!isAvailable(point.valuation)) {
    return { source: null, priceUpdated: null, fxRateText: null };
  }
  return {
    source: priceProvenanceText(point.priceProvenances),
    priceUpdated: priceUpdatedFor(point),
    fxRateText: point.fxAsOfDate
      ? `FX rate as of ${formatDate(point.fxAsOfDate, DateFormat.DMY_SPACE)}`
      : null,
  };
};
